import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col } from 'reactstrap';
import { FaCreditCard, FaCalendarAlt } from 'react-icons/fa';

const IuliPlanInfo = ({ iuliPlan, dateExpiryAt, companyId }) => {
  const momentDateExpiryAt = dateExpiryAt
    ? moment(dateExpiryAt, 'YYYY-MM-DD')
    : null;

  const className =
    !momentDateExpiryAt || momentDateExpiryAt.isAfter(moment())
      ? 'success'
      : 'danger';

  return (
    <Row>
      <Col className="mt-1" sm="12">
        <h3 className="mb-1 text-primary">
          <span className="align-middle">Plano Iuli</span>
        </h3>
      </Col>
      <Col sm="12">
        <hr className="my-1 w-100" />
      </Col>
      <Col sm="12" className="mb-1">
        <p className="mb-0">
          <strong>ID da Empresa:</strong> {companyId}
        </p>
      </Col>
      <Col sm="12" className="mb-1">
        <p className="mb-0">
          <strong>Plano Contratado:</strong> {iuliPlan?.name || 'Não informado'}
        </p>
      </Col>
      <Col sm="12">
        <p className="mb-0">
          <strong>Data de Expiração:</strong> <span className={className}>{momentDateExpiryAt ? momentDateExpiryAt.format('DD/MM/YYYY') : 'Plano Vitalício'}</span>
        </p>
      </Col>
    </Row>
  );
};

IuliPlanInfo.propTypes = {
  iuliPlan: PropTypes.shape({
    name: PropTypes.string,
  }),
  dateExpiryAt: PropTypes.string,
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

IuliPlanInfo.defaultProps = {
  dateExpiryAt: null,
};

export default IuliPlanInfo;
